import { render, staticRenderFns } from "./AdminContiRicaviView.vue?vue&type=template&id=63bac4f0&"
import script from "./AdminContiRicaviView.vue?vue&type=script&lang=ts&"
export * from "./AdminContiRicaviView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports